<template>
  <div>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <span class="title_head">Search User</span>
            </div>
            <div class="card-body">
              <div class="row">
                <div
                  class="col-sm-12 alert alert-success"
                  v-if="haserror.message != ''"
                  style="text-align: center;"
                >
                  {{ haserror.message }}
                </div>
              </div>

              <b-row>
                <b-col sm="3">
                  <b-form-group>
                    <label for="srch_uname"> Username </label><br />
                    <b-form-input
                      type="text"
                      placeholder="Enter Username"
                      v-model="search_uname"
                      name="srch_uname"
                      id="srch_uname"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <b-form-group>
                    <label for="user_status">Status </label><br />
                    <b-form-select
                      v-model="selected_status"
                      v-on:change="statuschange"
                      name="user_status"
                      id="user_status"
                    >
                      <option value="all">All</option>
                      <option value="active">Active</option>
                      <option value="locked">Locked</option>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col md="3">
                  <button
                    type="button"
                    class="btn btn-pill btn-primary serach_bttn"
                    style="margin-top: 22px;position: absolute;"
                    @click.prevent="getuser"
                  >
                    <i class="fa fa-search"></i> Search
                  </button>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-header">
              <div class="title_head">
                <b-row>
                  <b-col sm="8">User's List</b-col>
                  <b-col sm="4"
                    ><a
                      @click="inactive_user_list"
                      style="color: #1b8eb7; font-size: 14px; cursor: pointer;"
                      >View Inactive User</a
                    >&nbsp;&nbsp;
                    <button
                      type="button"
                      class="btn btn-sm btn-primary label_bttn"
                      @click="lockuser('lock')"
                    >
                      Lock</button
                    >&nbsp;&nbsp;<button
                      type="button"
                      class="btn btn-sm btn-primary label_bttn"
                      @click="lockuser('unlock')"
                    >
                      Unlock</button
                    >&nbsp;&nbsp;<button
                      type="button"
                      class="btn btn-sm btn-primary label_bttn"
                      @click="show_plan()"
                    >
                      Change Plan
                    </button></b-col
                  >
                </b-row>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12">
                  <div v-if="message.sucess != ''" class="alert alert-success">
                    <center>{{ message.sucess }}</center>
                  </div>
                </div>
              </div>
              <div class="table-responsive-sm">
                <vue-good-table
                  :columns="columns"
                  :rows="rows"
                  :select-options="{
                    enabled: true,
                  }"
                  mode="remote"
                  ref="my-table"
                  @on-column-filter="onColumnFilter"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :pagination-options="{ enabled: true, perPage: 10 }"
                  styleClass="vgt-table striped bordered table-sm condensed"
                >
                  <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'user_status'">
                      <span v-if="props.row.status === true">
                        <span class="badge badge-success">Active</span>
                      </span>
                      <span v-else>
                        <span v-if="props.row.locked === true">
                          <span class="badge badge-danger">Locked</span>
                        </span>
                        <span v-else>
                          <span class="badge badge-secondary">Inactive</span>
                        </span>
                      </span>
                    </span>
                    <span v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </span>
                  </template>
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      title="Inactive User Accounts"
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="warningModal"
      @ok="warningModal = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <vue-good-table
          :columns="columns1"
          :rows="rows1"
          mode="remote"
          ref="my-table1"
          @on-page-change="onPageChange1"
          @on-sort-change="onSortChange1"
          @on-column-filter="onColumnFilter1"
          @on-per-page-change="onPerPageChange1"
          :totalRows="totalRecords1"
          :pagination-options="{ enabled: true, perPage: 10 }"
          styleClass="vgt-table striped bordered table-sm condensed"
        >
          <template slot="table-row" slot-scope="props">
            <!-- {{ props.formattedRow[props.column.field] }} -->
            <span v-if="props.column.field == 'user_status'">
              <span class="badge badge-secondary">Inactive</span>
            </span>
            <span v-else-if="props.column.field == 'plan_type'">
              {{ plan_dt[parseInt(props.row.plan_type)].plan_label }}
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </b-collapse>
    </b-modal>
    <b-modal
      title="Select Plan"
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="planModal"
      @ok="planModal = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse3" visible>
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <label for="name">Choose Plan</label>
              <span style="display: flex;">
                <input
                  v-model="selplan"
                  type="radio"
                  id="free"
                  name="selplan"
                  v-bind:value="plan_dt[0].plan_type"
                />&nbsp;{{ plan_dt[0].plan_label }}
                &nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  v-model="selplan"
                  type="radio"
                  id="basic"
                  name="selplan"
                  v-bind:value="plan_dt[1].plan_type"
                />&nbsp;{{ plan_dt[1].plan_label }}
                &nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  v-model="selplan"
                  type="radio"
                  id="standard"
                  name="selplan"
                  v-bind:value="plan_dt[2].plan_type"
                />&nbsp;{{ plan_dt[2].plan_label }}
                &nbsp;&nbsp;&nbsp;&nbsp;
                <input
                  v-model="selplan"
                  type="radio"
                  id="professional"
                  name="selplan"
                  v-bind:value="plan_dt[3].plan_type"
                />&nbsp;{{ plan_dt[3].plan_label }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12">
            <b-form-group>
              <button
                class="btn btn-sm btn-primary btn-pill"
                type="button"
                @click="plan_select"
              >
                Submit
              </button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-collapse>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>
<script>
import Spinner from "../../spinner.vue";
export default {
  name: "Variant",
  components: { Spinner },
  data() {
    return {
      shpfrst_time: false,
      planModal: false,
      plan_dt_save: null,
      plan_dt: null,
      selplan: "1",
      selected_status: "all",
      warningModal: false,
      loading: false,
      search_uname: "",
      totalRecords: 0,
      totalRecords1: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      columns: [
        {
          label: "Company Name",
          field: "companyname",
          width: "20% !important",
        },
        {
          label: "Username",
          field: "username",
          width: "17% !important",
        },
        {
          label: "Email",
          field: "email",
          width: "20% !important",
        },
        {
          label: "Phone No.",
          field: "phone",
          width: "12% !important",
        },
        {
          label: "Registered Date",
          field: "created_datetime",
          width: "14% !important",
        },
        {
          label: "Active Days",
          field: "no_of_days",
          width: "14% !important",
        },
        {
          label: "Status",
          field: "user_status",
          width: "20% !important",
        },
        {
          label: "Plan",
          field: "plan",
          width: "13% !important",
        },
      ],

      columns1: [
        {
          label: "Company Name",
          field: "companyname",
          width: "20% !important",
        },
        {
          label: "Username",
          field: "username",
          width: "17% !important",
        },
        {
          label: "Email",
          field: "email",
          width: "20% !important",
        },
        {
          label: "Phone No.",
          field: "phone",
          width: "13% !important",
        },
        {
          label: "Registered Date",
          field: "created_datetime",
          width: "20% !important",
        },
        {
          label: "Status",
          field: "user_status",
          width: "20% !important",
        },
      ],

      rows: [],
      rows1: [],
      error: {
        errorname: false,
        errorided: "",
        errornameed: "",
        errorvalue: false,
      },
      message: {
        sucess: "",
        sucess1: "",
      },
      haserror: {
        message: "",
      },
    };
  },

  created() {
    Promise.all([this.plan()]).then((ret_val) => {
      this.plan_dt = this.plan_dt_save;
      this.getuser();
    });
  },

  methods: {
    plan_select() {
      this.planModal = false;
      if (this.$refs["my-table"].selectedRows.length > 0) {
        var selected_lock_user = this.$refs["my-table"].selectedRows.map(
          (item) => item.email
        );
        var _this = this;
        var data = { sel_plan: this.selplan, sel_user: selected_lock_user };
        this.loading = true;
        this.$http
          .post("/api/users/changeplan", data)
          .then(function (response) {
            // console.log(response);
            _this.loading = false;
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            _this.haserror.message =
              "Plan for selected user is changed Successfully";
            _this.getuser();
            setTimeout(function () {
              _this.haserror.message = "";
            }, 2000);
          })
          .catch(function (error) {
            _this.loading = false;
            console.log(error);
          });
        // console.log(selected_lock_user);
      } else {
        alert("Please select user first");
      }
    },

    show_plan() {
      this.planModal = true;
    },

    async plan() {
      var _this = this;
      this.plan_dt_save = {};
      this.$http
        .get("/api/plans")
        .then(function (response) {
          for (var i = 0; i < response.data.length; i++) {
            _this.plan_dt_save[response.data[i]["plan_type"]] = response.data[i];
            if (i === response.data.length - 1) {
              // console.log("zalllaa");
              return Promise.resolve(true);
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    inactive_user_list() {
      // console.log("inactive user list");
      this.rows1.length = 0;
      let filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      var _this = this;
      var api =
        "/api/users/inactive_user_detail?params=" + JSON.stringify(filteParam);
      // console.log(api)
      this.$http
        .get(api)
        .then(function (response) {
          if (response.data !== undefined) {
            _this.totalRecords1 = response.data[0].totalRecords;
            response.data.shift();
            _this.rows1 = response.data;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    lockuser(val) {
      // console.log(val);
      if (this.$refs["my-table"].selectedRows.length > 0) {
        var selected_lock_user = this.$refs["my-table"].selectedRows.map(
          (item) => item.email
        );
        var _this = this;
        var data = { lock_val: val, sel_user: selected_lock_user };
        this.$http
          .post("/api/users/lockuser", data)
          .then(function (response) {
            // console.log(response);
            _this.loading = false;
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            _this.haserror.message = "Selected users locked Successfully";
            _this.getuser();
            setTimeout(function () {
              _this.haserror.message = "";
            }, 2000);
          })
          .catch(function (error) {
            _this.loading = false;
            console.log(error);
          });
        // console.log(selected_lock_user);
      }
    },

    statuschange(val) {
      // console.log("status change");
      // console.log(val);
      this.selected_status = val;
      this.getuser();
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.getuser();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.getuser();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.getuser();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.getuser();
    },

    updateParams1(newProps) {
      this.serverParams1 = Object.assign({}, this.serverParams1, newProps);
    },

    onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.inactive_user_list();
    },

    onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.inactive_user_list();
    },

    onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.inactive_user_list();
    },

    onColumnFilter1(params) {
      this.updateParams1(params);
      this.inactive_user_list();
    },

    shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },

    datediff(register_date, current_date) {
      return Math.round((current_date - register_date) / (1000 * 60 * 60 * 24));
    },

    getuser() {
      // var filteParam = {};
      var data = "";
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      // console.log(this.serverParams.sort);
      // console.log(this.selected_status);
      var search_like = "";
      if (this.search_uname != "") {
        search_like = "&filter[where][search_uname]=" + this.search_uname;
      }
      var api = "/api/users/all_user_detail?params=" + JSON.stringify(filteParam) + search_like + "&filter[where][status]=" + this.selected_status;
      this.loading = true;
      var _this = this;
      this.$http
        .get(api)
        .then(function (response) {
          // console.log(response);
          if (response.data != undefined) {
            _this.totalRecords = response.data[0].totalRecords;
            response.data.shift();
            _this.rows = response.data;
            // console.log(_this.rows);
            var reg_date = null;
            var today = new Date();
            for (var i = 0; i < _this.rows.length; i++) {
              reg_date = new Date(_this.rows[i]["created_datetime"]);
              _this.rows[i]["no_of_days"] = _this.datediff(reg_date, today);
              _this.rows[i]["plan"] = _this.plan_dt[parseInt(_this.rows[i]["plan_type"])]["plan_label"];
            }
          }
          _this.loading = false;
        })
        .catch(function (error) {
          _this.loading = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/admin_pages/user_status_info.vue